import { useCallback, useEffect } from 'react';
import { useAssessmentsContext } from './useAssessmentsContext';
import { useAssessmentsAnswers } from './useAssessmentsAnswers';
import { useAssessmentsFormChangeDetection } from './useAssessmentsFormChangeDetection';

export const useAssessmentsNetworkStatus = () => {
  const {
    formMethods: { getValues },
  } = useAssessmentsContext();
  const { autoSaveAnswersImmediate } = useAssessmentsAnswers();
  const { shouldAutoSave, resetDirtyState } = useAssessmentsFormChangeDetection();

  const saveAssessmentsWhenOnline = useCallback(() => {
    // Only save if there are unsaved changes
    if (shouldAutoSave()) {
      const currentValues = getValues();
      autoSaveAnswersImmediate(currentValues, () => {
        // Reset dirty state after successful save
        // Note: resetDirtyState gets fresh values internally to avoid race conditions
        resetDirtyState();
      }).catch((error) => {
        // If save fails, keep dirty state so it will be attempted again
        // eslint-disable-next-line no-console
        console.error('Auto-save failed when coming online:', error);
      });
    }
  }, [shouldAutoSave, autoSaveAnswersImmediate, getValues, resetDirtyState]);

  useEffect(() => {
    window.addEventListener('online', saveAssessmentsWhenOnline);

    return () => {
      window.removeEventListener('online', saveAssessmentsWhenOnline);
    };
  }, [saveAssessmentsWhenOnline]);
};
